import { cn } from '@/lib/utils'

interface LogoIconProps {
  size?: number
  className?: string
}

/**
 * NovixOne logo mark — "N1 / AI" ligature: the numeral 1 shares the N's
 * right stroke, so the mark reads "N1" (all-in-one); the left two strokes
 * form a "Λ" (A) and the 1 doubles as an I, so it also reads "AI".
 */
export function LogoIcon({ size = 32, className }: LogoIconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      className={cn('shrink-0', className)}
      aria-label="NovixOne logo"
    >
      <rect width="32" height="32" rx="10" fill="#0E1220" />
      <path
        d="M7.5 23 L11 9 L19.5 23"
        stroke="#5B6CFF"
        strokeWidth="3.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.5 12.5 L23 9 L19.5 23"
        stroke="#FFFFFF"
        strokeWidth="3.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

interface LogoProps {
  size?: number
  showText?: boolean
  textClassName?: string
  subtitle?: string
  className?: string
}

export function Logo({ size = 32, showText = true, textClassName, subtitle, className }: LogoProps) {
  return (
    <div className={cn('flex items-center gap-2.5', className)}>
      <LogoIcon size={size} />
      {showText && (
        <div className="min-w-0">
          <div className={cn('font-semibold text-foreground tracking-tight', textClassName ?? 'text-sm')}>
            NovixOne
          </div>
          {subtitle && (
            <div className="text-[11px] text-muted-foreground truncate leading-tight mt-0.5">
              {subtitle}
            </div>
          )}
        </div>
      )}
    </div>
  )
}
